// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__83pOP","modalForm":"UpgradeEpcsModal_modalForm__1qNkE","modalFooter":"UpgradeEpcsModal_modalFooter__Z7wlH"};